export default __webpack_public_path__ + "static/media/Panda_Retro.e6c7b391.jpg";